/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "rolodexdiscovery": {
        "nested": {
          "service": {
            "nested": {
              "NumberRange": {
                "fields": {
                  "startAt": {
                    "type": "int32",
                    "id": 1,
                    "rule": "optional"
                  },
                  "endAt": {
                    "type": "int32",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "FloatNumberRange": {
                "fields": {
                  "startAt": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "endAt": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.rolodexdiscovery?.nested?.service?.nested?.NumberRange && !$root.nested?.squareup?.nested?.rolodexdiscovery?.nested?.service?.nested?.FloatNumberRange) {
  $root.addJSON(jsonData);
}

/**
 * Represents a generic number range. Ranges are customized to be
 * inclusive or exclusive based on the needs of a particular endpoint.
 * Refer to the relevant endpoint-specific documentation to determine
 * how these ranges are handled.
 *
 * SOURCE NumberRange @ squareup/rolodexdiscovery/number.proto at 12:1
 */
export const NumberRange = $root.lookupType('squareup.rolodexdiscovery.service.NumberRange');
fixType(NumberRange);
Builder.createAndAttachToType(NumberRange);
/**
 * Represents a generic floating-point number range. Ranges are customized to be
 * inclusive or exclusive based on the needs of a particular endpoint.
 * Refer to the relevant endpoint-specific documentation to determine
 * how these ranges are handled.
 *
 * SOURCE FloatNumberRange @ squareup/rolodexdiscovery/number.proto at 24:1
 */
export const FloatNumberRange = $root.lookupType('squareup.rolodexdiscovery.service.FloatNumberRange');
fixType(FloatNumberRange);
Builder.createAndAttachToType(FloatNumberRange);